<img [src]="path" alt="image" (error)="onError($event)" loading="lazy">
